import React from 'react'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'

import { Payment } from '../../../../types/payment'
import { PAYMENT_INFORMATION_DESCRIPTION } from '../../../../utils/payments'

export interface AttachmentProps {
  attachments?: Array<string>
}

export interface PaymentInformationProps {
  payment: Payment
  attachments?: Array<string>
}

const PaymentInformation = (props: PaymentInformationProps) => {
  const { details } = props.payment || {}
  const infoSections = [
    {
      description: PAYMENT_INFORMATION_DESCRIPTION.ACCOUNT_NAME,
      value: details.accountName,
    },
    {
      description: PAYMENT_INFORMATION_DESCRIPTION.ACCOUNT_NUMBER,
      value: details.accountNumber,
    },
    ...(details.memo
      ? [
          {
            description: PAYMENT_INFORMATION_DESCRIPTION.MEMO,
            value: details.memo,
          },
        ]
      : []),
    ...(props.attachments
      ? [
          {
            description: PAYMENT_INFORMATION_DESCRIPTION.ATTACHMENTS,
            value: props.attachments.map(attachment => (
              <Typography key={attachment}>{attachment}</Typography>
            )),
          },
        ]
      : []),
  ]
  return (
    <Box
      sx={theme => ({
        marginTop: theme.spacing(2),
      })}
    >
      {infoSections.map((info, index) => {
        const isLast = index === infoSections.length - 1
        return (
          <Box
            sx={theme => ({
              marginBottom: theme.spacing(isLast ? 0 : 1.875),
            })}
            key={info.description}
          >
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: 1.5,
                color: '#000000CC',
              }}
            >
              {info.value}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 400,
                lineHeight: 1.333,
                color: '#00000080',
              }}
            >
              {info.description}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}

export default PaymentInformation
